//////////////////////////////////////
// TRAVELING CLINICS LIST

import { renderPagination } from '../../../components/Pagination/pagination.js';

(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    const block = document.querySelector('.traveling-clinics-list');
    if (!block) return;

    const perPage  = parseInt(block.dataset.perPage, 10) || 5;
    const total    = parseInt(block.dataset.total, 10) || 0;
    const clinics  = Array.from(block.querySelectorAll('.clinic'));

    if (total <= perPage) return;

    let currentPage = 1;


    //////////////////////////////////////
    // RENDER

    function render() {
      const start = (currentPage - 1) * perPage;
      const end   = start + perPage;

      clinics.forEach((el, i) => {
        el.style.display = (i >= start && i < end) ? '' : 'none';
      });

      renderPagination({
        container:   block.querySelector('.pagination'),
        currentPage,
        totalItems:  total,
        perPage,
        label:       'Clinics',
        onPageChange(page) { currentPage = page; render(); }
      });
    }


    //////////////////////////////////////
    // INIT

    render();
  });
})();
